import { DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';
import { FileFilter } from './fileFilter';

type FileFilterMenuProps = {
  onFileFilterOpen: () => void;
  onFileFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
};

export const FileFilterMenu = ({
  onFileFilterClose,
  onFileFilterOpen,
  isOpened,
  anchorRef,
  type,
}: FileFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onFileFilterClose}
    >
      <FileFilter onCloseSideBar={onFileFilterClose} type={type} />
    </DropDownView>
  );
};
